export const PROCESS_STEP_KEYS = [
  'processStep1',
  'processStep2',
  'processStep3',
  'processStep4'
] as const

export const PROCESS_STEP_COPY: ReadonlyArray<{
  titleKeys: readonly [string, string]
  bodyKeys: readonly string[]
}> = [
  {
    titleKeys: ['processStep1Title1', 'processStep1Title2'],
    bodyKeys: ['processStep1Body1', 'processStep1Body2']
  },
  {
    titleKeys: ['processStep2Title1', 'processStep2Title2'],
    bodyKeys: ['processStep2Body1', 'processStep2Body2']
  },
  {
    titleKeys: ['processStep3Title1', 'processStep3Title2'],
    bodyKeys: ['processStep3Body1', 'processStep3Body2']
  },
  {
    titleKeys: ['processStep4Title1', 'processStep4Title2'],
    bodyKeys: ['processStep4Body1', 'processStep4Body2', 'processStep4Body3']
  }
]

export const REWARDS_CARD_COPY: ReadonlyArray<{
  titleKey: string
  bodyKey: string
  levelKey: string
  cardClassName?: string
  levelClassName: string
}> = [
  {
    titleKey: 'rewardsCard1Title',
    bodyKey: 'rewardsCard1Body',
    levelKey: 'rewardsCard1Level',
    levelClassName: 'rewardsWaysCardLevelGreen'
  },
  {
    titleKey: 'rewardsCard2Title',
    bodyKey: 'rewardsCard2Body',
    levelKey: 'rewardsCard2Level',
    cardClassName: 'rewardsWaysCardBlue',
    levelClassName: 'rewardsWaysCardLevelBlue'
  },
  {
    titleKey: 'rewardsCard3Title',
    bodyKey: 'rewardsCard3Body',
    levelKey: 'rewardsCard3Level',
    cardClassName: 'rewardsWaysCardPurple',
    levelClassName: 'rewardsWaysCardLevelPurple'
  },
  {
    titleKey: 'rewardsCard4Title',
    bodyKey: 'rewardsCard4Body',
    levelKey: 'rewardsCard4Level',
    cardClassName: 'rewardsWaysCardGold',
    levelClassName: 'rewardsWaysCardLevelGold'
  },
  {
    titleKey: 'rewardsCard5Title',
    bodyKey: 'rewardsCard5Body',
    levelKey: 'rewardsCard5Level',
    cardClassName: 'rewardsWaysCardRed',
    levelClassName: 'rewardsWaysCardLevelRed'
  }
] as const

export const FOOTBALL_IMG = '/assets/football.png'
export const BASKETBALL_IMG = '/assets/basketball.png'
export const AMERICAN_FOOTBALL_IMG = '/assets/american-football.png'
export const WHISTLE_IMG = '/assets/wheel.webp'
export const EYE_IMG = '/assets/eye.png'
export const ARROWS_IMG = '/assets/arrows.png'
export const DIALOG_BOX_IMG = '/assets/dialog-box.png'
export const CAMERA_IMG = '/assets/camera.png'
export const FIRE_IMG = '/assets/fire.png'

export const HIGHLIGHT_LEAD_ICONS = [
  '/assets/red-dot-first-variant.png',
  '/assets/red-dot-second-variant.png',
  '/assets/red-dot-third-variant.png',
  '/assets/red-dot-fourth-variant.png'
] as const

export const STADIUM_FANS_IMG = '/assets/stadium-fans.webp'

export const HIGHLIGHT_CARD_COPY = [
  { titleKey: 'highlightCard1Title', bodyKey: 'highlightCard1Body' },
  { titleKey: 'highlightCard2Title', bodyKey: 'highlightCard2Body' },
  { titleKey: 'highlightCard3Title', bodyKey: 'highlightCard3Body' },
  { titleKey: 'highlightCard4Title', bodyKey: 'highlightCard4Body' }
] as const

export const FANS_SECTION_FOOTER_GAP_PX = 100
